<script setup lang="ts">
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { BarometerCar, DetailsCarItemData } from '@autobid/ui/types/Car'
import { useAuction } from '@autobid/ui/composables/useAuction'

interface Props {
  car: BarometerCar | DetailsCarItemData | PreviewItemData
}

const props = defineProps<Props>()

const { auction } = useAuction(props.car.auctionId)
</script>

<template>
  <div
    v-if="
      car.supplier?.logo
        && auction?.activeStatusesNames?.includes('deliverer_logo')
    "
  >
    <img
      :src="car.supplier.logo"
      :alt="car.supplier.label"
      class="max-h-[44px]"
    >
  </div>
</template>
